<template>
  <v-layout row justify-center align-start v-resize="getDimensions">
    <v-flex>
      <v-card :height="height - 57">
        <v-app-bar color="white" elevate-on-scroll flat>
          <v-spacer></v-spacer>
          <div v-if="showSearchUsuario">
            <v-text-field
                    color="icons"
                    outlined
                    dense
                    v-model="searchUsuario"
                    @click:append="showSearchUsuario = !showSearchUsuario"
                    label="Búsqueda de Usuarios"
                    hide-details
                    append-icon="fa-solid fa-xmark"
                    prepend-icon="search"
                    hint="Pulse el botón a la izquierda para cambiar el tipo de búsqueda"
                  ></v-text-field>
          </div>
          <div v-else>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  large
                  @click="showSearchUsuario = !showSearchUsuario"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark>
                    {{ showSearchUsuario ? "search_off" : "search" }}
                  </v-icon>
                </v-btn>
              </template>
              <span>{{
                showSearchUsuario
                  ? "Ocultar filtros de búsqueda"
                  : "Mostrar filtros de búsqueda"
              }}</span>
            </v-tooltip>
          </div>
        </v-app-bar>
        <v-progress-linear
          :active="loadUsuario"
          :indeterminate="loadUsuario"
          absolute
          bottom
          color="primary"
        ></v-progress-linear>

        <v-sheet
          class="overflow-y-auto"
          :max-height="isMobile ? height - 120 : height - 120"
        >
          <v-card class="mx-auto" :max-width="width">
            <v-list two-line>
              <v-list-item-group
                v-model="selectedCliente"
                
              >
                <template>
                  <v-list-item v-for="item in filtrardtUsuario" :key="item.id">
                    <template v-slot:default="{active}">
                     
                      <v-list-item-avatar :color="item.estado=='A'?'success':'error'">
                        <v-icon color="white"> {{ item.estado=='A'?'fa-solid fa-user':'fa-solid fa-user-slash' }}</v-icon>
                      </v-list-item-avatar>


                      <v-list-item-content >
                        <v-list-item-title >
                          <strong>Usuario:</strong> {{ item.usuario }}
                        </v-list-item-title>
                        <v-list-item-title >
                          <strong>Nombre:</strong> {{ item.nombre }}
                        </v-list-item-title>
                        <v-list-item-title >
                          <strong>Rol:</strong> {{ item.rol }}
                        </v-list-item-title>
                       
                      </v-list-item-content>

                      <v-list-item-action  v-if="active">
                        <v-list-item-action-text
                          ><v-btn
                            class="mx-2"
                            fab
                            dark
                            small
                            color="primary"
                            @click="editUsuario( item)"
                          >
                            <v-icon dark> fa-solid fa-edit </v-icon>
                          </v-btn>
                          <v-btn
                            class="mx-2"
                            fab
                            dark
                            small
                            :color="item.estado=='A' ? 'error' : 'success'"
                            @click="abrirDialogActivacion(item)"
                          >
                            <v-icon dark
                              >{{item.estado == "A" ? 'block' : 'check' }}
                            </v-icon>
                          </v-btn>
                          
                        </v-list-item-action-text>
                      </v-list-item-action>
                      <v-list-item-action v-else>
                        <v-list-item-action-text>
                          <strong>Cargo:</strong> {{ item.cargo }}
                        </v-list-item-action-text>
                        <v-list-item-action-text>
                          <strong>Sucursal:</strong> {{ item.sucursal }}
                        </v-list-item-action-text>
                        <v-list-item-action-text>
                          <strong>Último Ingreso:</strong>{{ $formatoFechaSpanish(item.ultimo_ingreso) }}
                        </v-list-item-action-text>

                      </v-list-item-action>
                      
                    </template>
                  </v-list-item>
                </template>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-sheet>
      </v-card>
      <v-btn
        color="success"
        fab
        large
        @click="addUsuario"
        dark
        class="floating-button"
      >
        <v-icon>add</v-icon>
      </v-btn>

      <v-dialog v-model="dialogAlpha" persistent max-width="390">
        <v-card>
          <v-card-title>¿Está seguro?</v-card-title>
          <v-card-text
            >Esta acción {{ estado == "A" ? "desactivará" : "activará" }} el
            elemento seleccionado.</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogAlpha = false">Cancelar</v-btn>
            <div v-if="estado == 'A'">
              <v-btn color="primary" text @click="desactivar()"
                >Continuar</v-btn
              >
            </div>
            <div v-else>
              <v-btn color="primary" text @click="activar()">Continuar</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogBeta"
        :fullscreen="isMobile"
        :max-width="isMobile ? '100%' : '500px'"
        transition="dialog-bottom-transition"
      >
        <v-layout align-start v-resize="getDimensions">
          <v-flex>
            <v-card ref="form" id="lateral" :height="isMobile ? height : height - 100">
              <v-app-bar color="white" elevate-on-scroll flat>
                <v-card-title>
                  <span class="headline">Usuarios</span>
                </v-card-title>
                <v-spacer></v-spacer>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      @click="closeUsuario"
                      color="icons"
                      v-bind="attrs"
                      v-on="on"
                      fab
                    >
                      <v-icon dark> close </v-icon>
                    </v-btn>
                  </template>
                  <span>Cancelar</span>
                </v-tooltip>
              </v-app-bar>
              <v-sheet
                class="overflow-y-auto"
                :max-height="isMobile ? height - 60 : height - 60"
              >
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field
                        outlined
                        dense
                        ref="usuario"
                        v-model="usuario"
                        :readonly="!esEditado"
                        :rules="[$rules.requerido, $rules.max50]"
                        :error-messages="errorMessagesUsuario"
                        @keydown.enter.prevent="guardar"
                        @keydown.escape.prevent="cerrar"
                        label="Usuario"
                        required
                      ></v-text-field>
    
                      <v-autocomplete
                        outlined
                        dense
                        ref="id_rol"
                        v-model="id_rol"
                        :items="rolList"
                        :rules="[$rules.requerido]"
                        :error-messages="errorMessagesUsuario"
                        item-text="descripcion"
                        item-value="id"
                        label="Rol"
                        required
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-container>
              </v-sheet>

              <v-btn
                color="success"
                fab
                large
                dark
                class="floating-button"
                @click="saveUsuario"
              >
                <v-icon>done</v-icon>
              </v-btn>
            </v-card>
          </v-flex>
        </v-layout>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<style>
/* This is for documentation purposes and will not be needed in your application */
.floating-button {
  bottom: 0;
  right: 0;
  width: 90%;
  position: absolute;
  margin: 16px 16px 16px 16px;
}
</style>
<script>
import axios from "axios";
import dialogMixin from "../plugins/dialogs.js";


export default {
  mixins: [dialogMixin],
  data() {
    return {
      //variables globales
      user: this.$store.state.usuario.user,
      nombreUsuario: this.$store.state.usuario.nombre,
      idUsuario: this.$store.state.usuario.id,

      esEditado: false,
      id: 0,

      
      //Varibles Cliente
      cliente_codigo: "",
      cliente_id: "",
      showSearchUsuario: false,
      typeSearchUsuario: true,
      awaitingSearchCliente: false,
      searchCodUsuario: "",
      countCharCliente: 0,
      dtUsuario: [],
      loadUsuario: false,
      selectedCliente: [],

      //Variables de formato global
      width: 0,
      height: 0,
      isMobile: false,

      //Variables de banco

      usuario: "",
      id_rol: "",
      estado: "",

      dialogBeta: false,
      showSearchUsuario: false,
      searchUsuario: "",
      selectedUsuario: [],
      rolList: [],

     
      fechaActual: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
     
      errorMessagesUsuario: "",
      errorMessagesForm: "",
     
     
     



      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),

      showFechaValor: false,
      showUsuario: false,
      valida: 0,

      valorTipoId: 0,
      valorTipoDescripcion: "",
      valorTipoTipo: "",

     

      importeValor: 0,
      cantidadValor: 0,
      detailValor: "Sin valores seleccionados",

      dialogMu: false,
      dialogAlpha: false,
    };
  },

  watch: {
    typeSearchUsuario: function (val) {
      this.countCharCliente = this.searchCodUsuario.length;

      if (this.countCharCliente > 2) {
        this.loadUsuario = true;
        this.listarCliente();
      }
    },

    searchCodUsuario: function (val) {
      if (!this.awaitingSearchCliente) {
        setTimeout(() => {
          this.countCharCliente = this.searchCodUsuario.length;

          if (this.countCharCliente > 2) {
            this.loadUsuario = true;
            this.listarCliente();
          }
          this.awaitingSearchCliente = false;
        }, 1500); // 1 sec delay
      }
      this.awaitingSearchCliente = true;
    },
  },

  mounted() {
    this.getDimensions();
  },

  created() {
    this.$store.dispatch("actualizarTitulo", "Usuarios");
    this.listarUsuario();
    this.selectRoles();
  },
  beforeDestroy() {
    this.$store.dispatch("actualizarTitulo", "");
  },

  computed: {
    filtrardtUsuario() {
      return _.orderBy(
        this.dtUsuario.filter((item) => {
          if (!this.searchUsuario) return this.dtUsuario;
          return (
            (item.id.toString() || "")
              .toLowerCase()
              .includes(this.searchUsuario.toLowerCase()) ||
            (item.codigo || "")
              .toLowerCase()
              .includes(this.searchUsuario.toLowerCase()) ||
            (item.descripcion || "")
              .toLowerCase()
              .includes(this.searchUsuario.toLowerCase()) ||
            (item.estado || "")
              .toLowerCase()
              .includes(this.searchUsuario.toLowerCase())
          );
        }),
        "headline"
      );
    },

    

    formUsuario() {
      return {
        usuario: this.usuario,
        id_rol: this.id_rol,
      };
    },
    
  },
  methods: {
    getDimensions() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
      this.isMobile = this.width < 768;
    },

    listarUsuario() {
      let me = this;
      

      axios
        .get("api/usuarios/listar")
        .then(function (response) {
          me.dtUsuario = response.data;

          me.loadUsuario = false;
        })
        .catch(function (error) {
          me.loadUsuario = false;
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },

    selectRoles() {
      let me = this;
      axios
        .get("api/roles/select")
        .then(function (response) {
          me.rolList = response.data;
        })
        .catch(function (error) {
          console.error(error);
        });
    },

    activar() {
      let me = this;
      axios
        .put("api/usuarios/activar/" + me.id + "/" + me.user, {})
        .then(function (response) {
          me.listarUsuario();
          me.dialogAlpha = false;
          me.$store.dispatch("setSnackbar", {
            text: " Registro activado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.error(error);
        });
    },

    desactivar() {
      let me = this;
      axios
        .put("api/usuarios/desactivar/" + me.id + "/" + me.user, {})
        .then(function (response) {
          me.listarUsuario();
          me.dialogAlpha = false;
          me.$store.dispatch("setSnackbar", {
            text: "Registro desactivado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.error(error);
        });
    },

    abrirDialogActivacion(item) {
      this.id = item.id;      
      this.dialogAlpha = true;
      this.estado = item.estado;
    },
    


   
    cleanUsuario() {
      this.usuario = "";
      this.id_rol = "";
      this.esEditado = false;
    },

    closeUsuario() {
      this.dialogBeta = false;

      this.cleanUsuario();
    },

    editUsuario(item) {
      this.id = item.id;
      this.usuario = item.usuario;
      this.id_rol = item.id_rol;
      this.esEditado = true;

      this.dialogBeta = true;
    },

    

    addUsuario() {
      this.usuario = "";
      this.id_rol = "";
      this.esEditado = false;
      this.dialogBeta = true;
    },

    saveUsuario() {
      let me = this;
      if (this.validarUsuario() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }

      if (this.esEditado) {
        axios
          .put("api/usuarios/actualizar", {
            id: me.id,
            codigo: me.usuario,
            descripcion: me.id_rol,
            usuario: me.user,
          })
          .then(function (response) {
            me.closeUsuario();
            me.listarUsuario();
            me.$store.dispatch("setSnackbar", {
              text: "Usuario modificado exitosamente. ",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      } else {
        axios
          .post("api/usuarios/crear", {
            codigo: me.usuario,
            descripcion: me.id_rol,
            usuario: me.user,
          })
          .then(function (response) {
            me.closeUsuario();
            me.listarUsuario();
            me.$store.dispatch("setSnackbar", {
              text: "Usuario creado exitosamente. ",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      }
    },

    redondear(num) {
      var res = 0;
      if (num < 0.000001 && num > -0.000001) res = 0;
      else res = +(Math.round(num + "e+2") + "e-2");

      return res;
    },
    formatoNumero(num) {
      return num.toLocaleString("en", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    quitarformatoNumero(num) {
      return num.replace(/,/g, "");
    },
    formatoFecha(fecha) {
      if (fecha == null) {
        return null;
      } else {
        if ((fecha != "") & (fecha != "0001-01-01T00:00:00")) {
          try {
            var m = new Date(fecha);
            var dateString =
              m.getUTCFullYear() +
              "-" +
              ("0" + (m.getUTCMonth() + 1)).slice(-2) +
              "-" +
              ("0" + m.getUTCDate()).slice(-2);
            return dateString;
          } catch (error) {
            console.error(error);
          }
        } else {
          return "";
        }
      }
    },
    

    estaVencido(fecha) {
      var fechaActual = new Date();
      var fechaVencimiento = new Date(fecha);
      if (fechaActual > fechaVencimiento) {
        return true;
      } else {
        return false;
      }
    },

    validarUsuario() {
      this.valida = 0;

      Object.keys(this.formUsuario).forEach((f) => {
        this.$refs[f].validate(true);
        if (this.$refs[f].validate(true)) {
          this.valida += 0;
        } else {
          this.valida += 1;
        }
      });
      return this.valida;
    },
  },
};
</script>
